import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { Button } from "@mui/material";
import AddForm from "./addForm";
import {
  useGetServiceTypeQuery,
  useAddServiceTypeMutation,
  useUpdateServiceTypeMutation,
  useDeleteServiceTypeMutation,
} from "slices/beautyApp/serviceType";
import { hasActionAccess } from "utility";
import { useSelector } from "react-redux";

function SubCatServices() {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [add] = useAddServiceTypeMutation();
  const [update] = useUpdateServiceTypeMutation();
  const [del] = useDeleteServiceTypeMutation();
  const auth = useSelector((state) => state.auth.auth?.user);

  const {
    data: servType,
    isLoading,
    refetch,
  } = useGetServiceTypeQuery({
    page,
    limit,
    search,
  });

  const col = [{ display: "Name", key: "name", type: "display" }];

  const canEdit = hasActionAccess(
    auth,
    "Beauty App",
    "Sub Cat-services",
    "edit"
  );
  const canDelete = hasActionAccess(
    auth,
    "Beauty App",
    "Sub Cat-services",
    "delete"
  );

  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onEdit = (row) => {
    setEditing(row);
    setOpen(true);
  };

  const handleAdd = () => {
    setEditing(null);
    setOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this sub-category?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const handleSubmit = async (data) => {
    try {
      if (editing) {
        await update({ id: data._id, body: data }).unwrap();
        refetch();
      } else {
        await add(data).unwrap();
        refetch();
      }
      setOpen(false);
    } catch (e) {
      console.log("e===========>", e);
    }
  };

  const canAdd = hasActionAccess(auth, "Beauty App", "Sub Cat-services", "add");

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AddForm
        open={open}
        onClose={() => setOpen(false)}
        initialData={editing}
        onSubmit={handleSubmit}
      />
      {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add Service Type
        </Button>
      )}

      <Tables
        title={"Sub-Cat Services"}
        handleSearch={handleSearchChange}
        totalPages={servType?.data.pagination?.totalPages}
        data={servType?.data.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default SubCatServices;
